var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UsersList"},_vm._l((_vm.users),function(user){return _c('div',{key:user.id,staticClass:"user"},[_c('input',{staticClass:"input",attrs:{"placeholder":"Type in user's name!"},domProps:{"value":user.name},on:{"input":function (e) {
          _vm.update(user, e.target.value);
        }}}),_c('p',{staticClass:"tasks"},[_vm._v(_vm._s(user.todos.length)+" Tasks")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }